import { render } from "./Institution.vue?vue&type=template&id=634e6cd3&scoped=true"
import script from "./Institution.vue?vue&type=script&lang=js"
export * from "./Institution.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634e6cd3"]])

export default __exports__